<template>
    <div class="alert d-flex flex-row justify-content-center align-item-center py-2 px-2 border m-0">
        <div class="alert-column">
            <img :src="require(`@/assets/img/alerts/${alert.icon}.png`)" class="alert-img">
            <TimeCount :time="time"></TimeCount>
        </div>
        <div class="alert-column" style="width: 200px;">
            <p class="title-alert text-decoration-underline fw-bold mb-1 w-100">{{ alert.title }}</p>
            <div class="device-alert d-flex flex-row w-100 align-items-center">
                <img :src="require(`@/assets/img/devices/${alert.device_icon}.png`)" class="me-1">
                <strong class="plate-alert">{{ alert.plate }}</strong>
            </div>
            <div class="data-alert w-100">
                <div class="d-flex flex-row w-100" v-for="(item, index) in alert.data" :key="index">
                    <strong class="me-1">{{ item.title }}</strong>
                    <p>{{ item.value }}</p>
                </div>
            </div>
        </div>
        <div class="alert-column position-div">
            <img src="@/assets/img/alert-position.svg" class="position-img" @click="centerAlert">
        </div>
    </div>
</template>

<script lang="ts">
import TimeCount from '@/components/TimeCount.vue'
import IAlert from '@/models/modelView/IAlert'
import AlertFeature from '@/services/maps/features/alert.feature'
import VectorService from '@/services/vector.service'
import globalModule from '@/store/modules/global.module'
import mapsModule from '@/store/modules/maps.module'
import DateUtil from '@/utils/date.util'
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'

@Component({
    components: {
        TimeCount
    }
})
export default class ItemAlert extends Vue {
    @Prop(Object) readonly alert!: IAlert
    time = ''
    get nowTime() {
        return globalModule.nowTime
    }

    @Watch("nowTime", { immediate: true })
    onChangeNowTime(date: Date): void {
        this.time = DateUtil.getStringDiff(date, this.alert.time) || ''
    }

    centerAlert() {
        VectorService.clearVectorSource(6)
        VectorService.insertFeatures(6, [new AlertFeature(this.alert).create()])
        this.$router.push('/maps')
        mapsModule.mapService.centerPoint({
            latitude: this.alert.latitude,
            longitude: this.alert.longitude
        })
    }
}
</script>

<style lang="sass" scoped>
    p
        margin: 0px
    .alert
        border: 1px solid rgba(40, 84, 239, .7)!important
        border-radius: 0px
    .alert-column
        display: flex
        flex-direction: column
        align-items: center
        justify-content: center
        padding: 0px 8px
    .position-div
        padding: 0px 4px

    .title-alert
        text-underline-offset: 5px
        font-size: 16px
    .device-alert
        img
            height: 25px
    .alert-img
        height: 70px
    .position-img
        height: 30px
        transition: all 0.1s ease
        &:active
          transform: scale(0.9)
    .data-alert
        font-size: 14px  
</style>